import tw from 'twin.macro';

import { Modal } from '@/components/base';
import { GetTemplatesQuery } from '@/libs/graphql';

type Template = NonNullable<GetTemplatesQuery['getTemplates']>[number];

type Props = {
  template: Template;
  loading?: boolean;
  errorMessage?: string;
  onConfirm: () => void;
  onClose: () => void;
};

const DeleteTemplateModal = ({ template, loading, errorMessage, onConfirm, onClose }: Props) => {
  return (
    <Modal
      title="ลบชุดคำถาม"
      description={
        <>
          <p tw="text-gray-500">
            {`คุณต้องการลบชุดคำถาม "${template.name}" ใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้`}
          </p>
          {errorMessage && <p tw="mt-2 text-red-600">{errorMessage}</p>}
        </>
      }
      primaryButtonText="ลบ"
      primaryButtonAction={onConfirm}
      secondaryButtonText="ยกเลิก"
      secondaryButtonAction={onClose}
      loading={loading}
    />
  );
};

export default DeleteTemplateModal;
